import React from 'react';
import {
  getStaffDisplayName,
  getStaffRoleLabel,
  sortStaffForPicker,
} from '../lib/staff';

/**
 * Staff picker for intervention leads — flat list with role labels (works in all browsers).
 */
export default function StaffLeadSelect({
  staff = [],
  value,
  onChange,
  loading = false,
  disabled = false,
  className = 'flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm',
  placeholder = 'Select staff member',
  emptyLabel = 'No active staff',
  showCountHint = true,
}) {
  const sorted = sortStaffForPicker(staff);

  return (
    <div className="flex-1 min-w-0">
      <select
        value={value}
        onChange={onChange}
        disabled={disabled || loading}
        className={className}
      >
        <option value="">{placeholder}</option>
        {loading ? (
          <option disabled>Loading…</option>
        ) : staff.length === 0 ? (
          <option disabled>{emptyLabel}</option>
        ) : (
          sorted.map((s) => (
            <option key={s.id} value={s.id}>
              {getStaffDisplayName(s)}, {getStaffRoleLabel(s.role)}
            </option>
          ))
        )}
      </select>
      {showCountHint && !loading && staff.length > 0 && (
        <p className="mt-1 text-xs text-gray-500">
          {staff.length} staff available (incl. SLT, OT, EP, Physio)
        </p>
      )}
    </div>
  );
}
